module.exports = __webpack_public_path__ + "img/ic_wechat_nor-1.e7428e1b.svg";